import React, { useEffect, useMemo } from 'react';
import { Redirect, Route, Switch, useHistory, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { ROUTE_DASHBOARD, ROUTE_GOVCRM_CONTACTS } from '../../constants';
import Suspense from '../../services/lazyLoad/Suspense';
import { errorAlert } from '../../contexts/AlertContext';
import { useTrans } from '../../services/i18n';
import CrmEmailLinkSwitchDialog from './CrmEmailLinkSwitchDialog';
import { CRM_EMAIL_LINK_KINDS, readCrmEmailLink, stripCrmEmailLink } from './crmEmailLink';

const Contacts = React.lazy(() => import('./Contacts'));

export default function GovCrm() {
  // Org-level CRM gate driven by the Salesforce GovConCrmAccess__c flag. The flag
  // is resolved server-side and delivered via organization.getOrganizationInfo.
  const crmAccessEnabled = useSelector((state) => state.orgSettings.crmAccessEnabled === true);
  const authUser = useSelector((state) => state.auth);
  const location = useLocation();
  const history = useHistory();
  const { trans } = useTrans();
  const link = useMemo(() => readCrmEmailLink(location.search, authUser), [authUser, location.search]);
  const noAccess = link.kind === CRM_EMAIL_LINK_KINDS.NO_ACCESS;

  useEffect(() => {
    if (!noAccess) return;
    errorAlert('error-title', trans('crm-email-link-no-access'));
    stripCrmEmailLink(location, history);
  }, [noAccess, history, location, trans]);

  if (link.kind === CRM_EMAIL_LINK_KINDS.SWITCH) {
    return <CrmEmailLinkSwitchDialog link={link} />;
  }

  if (noAccess) {
    return null;
  }

  if (!crmAccessEnabled) {
    return <Redirect to={ROUTE_DASHBOARD.path} />;
  }

  return (
    <Suspense>
      <Switch>
        <Route exact path={ROUTE_GOVCRM_CONTACTS.path}>
          <Contacts />
        </Route>
        <Redirect exact path="/*" to={ROUTE_GOVCRM_CONTACTS.path} />
      </Switch>
    </Suspense>
  );
}
